import React, {useState} from 'react';
import ConfirmWithQuestionDialog from "../../general/ConfirmWithQuestionDialog";
import TournamentX01Area from "./TournamentX01Area";
import ErrorInfoComponent from "../../general/ErrorInfoComponent";
import FetchUtil from "../../../util/FetchUtil";
import ConfigUtil from "../../../util/ConfigUtil";

export default function LigaspieltagNewTeamGame({tournamentId, onRefresh, onClose}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [sets, setSets] = useState(undefined)
    const [firstToLegs, setFirstToLegs] = useState(undefined)
    const [bestToLegs, setBestToLegs] = useState(undefined)
    const [modusId, setModusId] = useState(undefined)
    const [startpunkte, setStartpunkte] = useState(undefined)

    const beschreibungArea = () => {
        return <div style={{color: "red"}}>
            Du kannst hier ein Team-Game anlegen.<br/>
            Sofern du ein Team-Game angelegt hast, kannst du dieses nicht mehr
            löschen!<br/>
            <br/>
            Normal wird das Team-Game nur angelegt, sofern das Gesamtergebnis
            unentschieden ist.<br/>
            Wir lassen dir jedoch die Option immer ein Team-Game anzulegen.<br/>
        </div>
    }

    const modusArea = () => {
        return <TournamentX01Area showSets={true} showBestOfLegs={true} showPflichtfelder={true}
                           sets={sets}
                           firstToLegs={firstToLegs}
                           bestOfLegs={bestToLegs}
                           modusId={modusId} startpunkte={startpunkte}
                           onSetsChanged={(sets) => setSets(sets)}
                           onFirstToLegsChanged={(firstToLegs) => setFirstToLegs(firstToLegs)}
                           onBestOfLegsChanged={(bestOfLegs) => setBestToLegs(bestOfLegs)}
                           onModusIdChanged={(modusId) => setModusId(modusId)}
                           onStartpunkteChanged={(startpunkte) => setStartpunkte(startpunkte)}/>
    }

    const canSave = () => {
        return sets && (firstToLegs || bestToLegs) && modusId && startpunkte
    }

    const saveTeamGame = () => {
        setErrorMessage(undefined);
        if( !canSave()) {
            setErrorMessage("Fülle den Spielmodus komplett aus.");
            return;
        }


        let modus = {
            gameType: "x01",
            modusid: modusId,
            sets: sets,
            firstToLegs: firstToLegs,
            bestOfLegs: bestToLegs,
            startpunkte: startpunkte,
        }

        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.ligaspieltag + "/save/teamgame/" + tournamentId,
            modus,
            () => {
                onRefresh();
                onClose();
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
            })
    }

    return <ConfirmWithQuestionDialog header="Wichtig..."
                                      textOben={<>
                                          <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)} onClearErrorMessage={() => setErrorMessage(undefined)}/>
                                          <div>
                                              {beschreibungArea()}
                                          </div>
                                          <div style={{marginTop:20}}>
                                              <div style={{marginBottom:10}}>
                                                  Wählen den Modus des Team-Games:
                                              </div>
                                              <div style={{marginTop: 10, alignItems: "center"}}>
                                                  {modusArea()}
                                              </div>
                                          </div>
                                      </>}
                                      textUnten="Möchtest du das Team-Game wirklich anlegen?"
                                      visible={true}
                                      textJaButton={"Team-Game anlegen"}
                                      textNeinButton={"Abbrechen"}
                                      callBackOnNein={() => onClose()}
                                      callBackOnJa={() => saveTeamGame()}/>

}